import { Component, ViewChild } from '@angular/core';
import { FormControl, FormBuilder ,FormGroup } from '@angular/forms';
import { MessageService, MobileCountryInfo } from '../../message.Service';
import { TranslateService } from '@ngx-translate/core';
import { NetworkService } from '../../network.Service';
import { Organization, AuthenticationService, OrganizationModel } from "../../authentication.Service";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MediaService } from '../../media.Service';
import { MessageModel } from "../../message.Service";
import { SmsEditorComponent } from '../../Development/sms-editor/sms-editor.component';

class OrgList {
  selected: boolean;
  icon: string;
  name: string;
  email: string;
  value: number;
  memberId: number;
  mediaId: number;
  mediaService: MediaService;

  constructor(selected: boolean, icon: string, name: string, email: string, value: number, memberId: number, mediaId: number,
    mediaService: MediaService) {
    this.selected = selected;
    this.icon = icon;
    this.name = name;
    this.email = email;
    this.value = value;
    this.memberId = memberId;
    this.mediaId = mediaId;
    this.mediaService = mediaService;
  }

  get media() {
    if (this._media != null) {
      return this._media == "" ? null : this._media;
    }

    if (this.mediaId == 0) {
      this._media = "";
      return null;
    }

    this.mediaService.getMediaById(this.mediaId).subscribe(
      result => {
        this._media = result;
      },
      error => {
        this._media = "";
      });
  }
  private _media = null;
}

@Component({
  selector: 'app-senderid',
  templateUrl: './senderid.component.html',
  styleUrl: './senderid.component.css'
})
export class SenderidComponent {

  formGroup: FormGroup;
  errorMsg: string;
  displayError: boolean;
  displaySuccess: boolean;
  dataReady: boolean = false;
  countrycode: number = 0;
  countries: MobileCountryInfo[] = [];
  isAdminView = false;
  isMemberView = true;
  tempOrgs?: Observable<Organization[]>;
  orgPageSize: number = 20;
  userId: number = 0;
  organizations: Organization[] = [];
  orgList: OrgList[] = [];
  selectedOrg?: OrgList;
  ownOrganizations: boolean = false;
  message: string = "";

  @ViewChild('sms') public sms: SmsEditorComponent | undefined;

  constructor(private fb: FormBuilder,
    private authService: AuthenticationService,
    public translate: TranslateService,
    private messageService: MessageService,
    private networkSerivce: NetworkService,
    private mediaService: MediaService
  ) {
    this.errorMsg = "";
    this.displayError = false;
    this.displaySuccess = false;
    this.messageService.getCountries().subscribe(result => {
      this.countries = result;
      this.orgList = [];
      this.checkOrg();
    });

    this.formGroup = new FormGroup({
      Country: new FormControl(),
      Organization: new FormControl(),
      Type: new FormControl("sms"),
      SenderID: new FormControl(),
      brandtype: new FormControl(),
      traffictype: new FormControl(),
      CompanyName: new FormControl(),
      CompanyRepName: new FormControl(),
      CompanyRepRole: new FormControl(),
      CompanyContact: new FormControl(),
      CompanyVolume: new FormControl(),
      SampleMessage: new FormControl(),
      URLformat: new FormControl(),
      ServiceDescription: new FormControl(),
      CompanyWebsite: new FormControl()
    });
  }

  isSms(): boolean {
    return this.formGroup.controls.Type.value == "sms";
  }

  checkOrg() {
    let userId = this.authService.getUserId();

    this.authService.getOrganizationSummariesForMember().subscribe(result => {
      /*let m = this.orgList[0];
      m.selected = false;*/
      this.orgList = [];
      this.organizations = result;
      //this.orgList.push(m);
      let i = this.authService.currentOrganization();
      let found = false;
      /*for (let j = 0; j < this.organizations.length; j++) {
        let org = this.organizations[j];
        let o = new OrgList(false, org.OrganizationId == i ? 'supervised_user_circle' : 'supervisor_account', org.Name, "", org.OrganizationId, org.MemberId, org.MediaId, this.mediaService);
        if (org.RoleId == 5) {
          this.ownOrganizations = true;
        }

        if (o.value == i) {
          found = true;
          this.selectedOrg = o;
        }
        else {
          this.orgList.push(o);
        }
      }*/
    });
  }

  newSearch() {
    this.networkSerivce.senderidrequest(this.formGroup.value.Organization?.name,this.formGroup.value.Country?.Country, this.formGroup.value.SenderID,
     this.formGroup.value.CompanyName, this.formGroup.value.CompanyWebsite,
      this.formGroup.value.CompanyRepName, this.formGroup.value.CompanyRepRole, this.formGroup.value.CompanyContact,
      this.formGroup.value.CompanyVolume, this.sms?.text ?? "", this.formGroup.value.URLformat,
      this.formGroup.value.ServiceDescription,this.formGroup.value.brandtype, this.formGroup.value.traffictype)
      .subscribe(result => {
        this.displayError = false;
        this.displaySuccess = true;
      },
        error => {
          console.error(error);
          this.errorMsg = "There was a problem Sending your SenderID Request. Please Try again later.";
          this.displayError = true;
        });
  }
}
